export const Role = {
  Admin: "ADMIN",
  Driver: "DRIVER",
  Warehouse: "WAREHOUSE",
  Factory: "FACTORY",
  Owner: "OWNER",
  User:'USER'
};
